import { render, staticRenderFns } from "./Moderation.vue?vue&type=template&id=701cb3ed"
import script from "./Moderation.vue?vue&type=script&lang=js"
export * from "./Moderation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('701cb3ed')) {
      api.createRecord('701cb3ed', component.options)
    } else {
      api.reload('701cb3ed', component.options)
    }
    module.hot.accept("./Moderation.vue?vue&type=template&id=701cb3ed", function () {
      api.rerender('701cb3ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/section/Moderation.vue"
export default component.exports